import {
    AccordionItem,
    AccordionPanel,
    Stack,
    Box,
    Text,
} from '@chakra-ui/react';
import { Select as NumberSelect } from 'chakra-react-select';
import { FormControl, FormLabel } from '@/components/v4';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
    dropDownFormStyle,
} from 'components/forms/new/formStyles';
import RingGroupAccordionSectionButton from './RingGroupAccordionSectionButton';

export default function RingGroupPhoneNumbersSection({
    values,
    setFieldValue,
    fullNumberList,
    isLoadingNumbers,
    darkMode,
    panelBg,
    accordionBorderColor,
}) {
    const selectedNum =
        fullNumberList.find((n) => n.numberID === values.primaryNumberId) ||
        null;

    return (
        <AccordionItem
            borderColor={accordionBorderColor}
            mb={2}
            borderWidth="1px"
            borderRadius="md"
            overflow="hidden">
            <RingGroupAccordionSectionButton darkMode={darkMode}>
                Phone Numbers
            </RingGroupAccordionSectionButton>
            <AccordionPanel px={4} py={4} bg={panelBg}>
                <Stack spacing={1}>
                    {/* Primary Number */}
                    <FormControl sx={{ margin: '0 !important' }}>
                        <Stack
                            direction="row"
                            spacing={stackSpacing}
                            sx={stackStyling()}>
                            <FormLabel sx={formLabelStyling(darkMode)}>
                                Primary Number
                            </FormLabel>
                            <Box flex="1" pt="15px">
                                <NumberSelect
                                    options={fullNumberList}
                                    value={selectedNum}
                                    getOptionLabel={(n) => n.telephoneNumber}
                                    getOptionValue={(n) => n.numberID}
                                    onChange={(item) =>
                                        setFieldValue(
                                            'primaryNumberId',
                                            item?.numberID || '',
                                        )
                                    }
                                    placeholder="Not Allocated"
                                    isClearable
                                    isLoading={isLoadingNumbers}
                                    isDisabled={isLoadingNumbers}
                                    chakraStyles={dropDownFormStyle(darkMode)}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                        }),
                                    }}
                                />
                                {selectedNum?.trunkType && (
                                    <Text
                                        fontSize="xs"
                                        color={
                                            darkMode ? 'gray.400' : 'gray.500'
                                        }
                                        mt={1}>
                                        Trunk: {selectedNum.trunkType}
                                    </Text>
                                )}
                            </Box>
                        </Stack>
                    </FormControl>
                </Stack>
            </AccordionPanel>
        </AccordionItem>
    );
}
